import React, { useEffect, useState } from 'react';
import { Box, Grid, InputLabel, Typography, Popover, Button, TextField, Checkbox, FormControlLabel } from '@mui/material';
import DrawIcon from '@mui/icons-material/Draw';
import CreateIcon from '@mui/icons-material/Create';
import { Formik, Form } from 'formik';

interface EsignComponentProps {
  values: any;
  index: number;
  childIndex: number;
  setFieldValue: (key: string, value: any) => void;
}

function EsignComponent({ values, index, childIndex, setFieldValue }: EsignComponentProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'edit-esign-popover' : undefined;

  const child = values.fields[index].children[childIndex];

  useEffect(() => {
    const child = values.fields[index].children[childIndex];
    console.log(values.fields[index].children[childIndex], 'child');
    console.log(child, 'Child in EsignComponent');
  }, []);

  return (
    <Box>
      <Grid container alignItems="center" spacing={1}>
        <Grid item xs={11}>
          <InputLabel sx={{ color: 'black', display: 'flex', alignItems: 'center', gap: 1 }}>
            {child.question}
            <DrawIcon fontSize="medium" sx={{ color: 'primary.main' }} />
          </InputLabel>
        </Grid>
        <Grid item xs={1}>
          <Box sx={{ cursor: 'pointer', color: 'primary.main' }} onClick={handleOpen}>
            <CreateIcon fontSize="medium" />
          </Box>
        </Grid>
      </Grid>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        PaperProps={{ sx: { width: 350, p: 2 } }}
      >
        <Formik
          initialValues={{
            label: child.question || '',
            required: child.settings?.required || false,
            isSupportFileRequired: child.settings?.isSupportFileRequired || false,
            noOfSupportImages: child.settings?.noOfSupportImages || ''
          }}
          enableReinitialize
          onSubmit={(formValues) => {
            setFieldValue(`fields.${index}.children.${childIndex}.question`, formValues.label);
            setFieldValue(`fields.${index}.children.${childIndex}.settings.required`, formValues.required);
            setFieldValue(`fields.${index}.children.${childIndex}.settings.isSupportFileRequired`, formValues.isSupportFileRequired);
            setFieldValue(
              `fields.${index}.children.${childIndex}.settings.noOfSupportImages`,
              formValues.isSupportFileRequired ? formValues.noOfSupportImages : ''
            );
            handleClose();
          }}
        >
          {({ values: formValues, handleChange }) => (
            <Form>
              <Typography variant="subtitle1" mb={2}>
                Edit E-Signature Settings
              </Typography>

              <Grid container spacing={2} alignItems="center">
                <Grid item xs={4}>
                  <InputLabel>Label</InputLabel>
                </Grid>
                <Grid item xs={8}>
                  <TextField fullWidth name="label" value={formValues.label} onChange={handleChange} size="small" />
                </Grid>

                <Grid item xs={12}>
                  <FormControlLabel
                    control={<Checkbox name="required" checked={formValues.required} onChange={handleChange} color="primary" />}
                    label="Required"
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="isSupportFileRequired"
                        checked={formValues.isSupportFileRequired}
                        onChange={handleChange}
                        color="primary"
                      />
                    }
                    label="Support File Required"
                  />
                </Grid>

                {formValues.isSupportFileRequired && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      name="noOfSupportImages"
                      type="number"
                      label="Number of Images"
                      value={formValues.noOfSupportImages}
                      onChange={handleChange}
                      size="small"
                      inputProps={{ min: 1 }}
                      sx={{ mt: 1 }}
                    />
                  </Grid>
                )}

                <Grid item xs={12}>
                  <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button type="submit" size="small" variant="contained">
                      Save
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Popover>
    </Box>
  );
}

export default EsignComponent;
